import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import conf from "../../../config.js";

export default class RekapStatistik extends React.Component {
    constructor(props) {
        super(props);
        const now = new Date();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        const defaultTA = month >= 7 ? `${year} / ${year + 1}` : `${year - 1} / ${year}`;
        const defaultSem = month >= 7 ? "1" : "2";

        this.state = {
            institusi_id: "",
            tahun_ajaran: defaultTA,
            semester: defaultSem,
            kurikulum: "merdeka",
            loading: true,
            tab: "guru",
            rekap_guru: [],
            rekap_mapel: [],
            bentrokan: [],
            total_bentrokan: 0,
            versi_list: [],
            selected_versi: "",
        };
    }

    componentDidMount() { this.getSession(); }

    getSession() {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios.post(`${conf.uri_backend}api/v1/auth/sso/user`, { token: localStorage.getItem("token") }, { headers: { Authorization: tokenApi } })
            .then((res) => {
                const npsn = res.data.access_to;
                axios.get(`${conf.uri_backend}api/v1/select-institusi/${npsn}`, { headers: { Authorization: tokenApi } })
                    .then((instRes) => {
                        this.setState({ institusi_id: instRes.data.id }, () => {
                            this.loadVersi();
                            this.loadAll();
                        });
                    })
                    .catch(() => {
                        this.setState({ institusi_id: npsn }, () => {
                            this.loadVersi();
                            this.loadAll();
                        });
                    });
            });
    }

    getApiHeaders() { return { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }; }
    getBaseParams() { return `institusi=${this.state.institusi_id}&tahun_ajaran=${this.state.tahun_ajaran}&semester=${this.state.semester}&kurikulum=${this.state.kurikulum}`; }

    getTahunAjaranOptions() {
        const now = new Date();
        const year = now.getFullYear();
        const options = [];
        for (let y = year + 1; y >= year - 3; y--) {
            options.push(`${y} / ${y + 1}`);
        }
        return options;
    }

    onFilterChange(partial) {
        this.setState({ ...partial, selected_versi: "", rekap_guru: [], rekap_mapel: [], bentrokan: [], total_bentrokan: 0, versi_list: [], loading: true }, () => {
            this.loadVersi();
            this.loadAll();
        });
    }

    loadVersi() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/versi?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => { if (res.data.status) this.setState({ versi_list: res.data.data }); });
    }

    loadAll() {
        const h = this.getApiHeaders();
        const versiParam = this.state.selected_versi ? `&versi_id=${this.state.selected_versi}` : "";

        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/rekap/guru?${this.getBaseParams()}${versiParam}`, h)
            .then((res) => { if (res.data.status) this.setState({ rekap_guru: res.data.data }); })
            .catch(() => { });
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/rekap/mapel?${this.getBaseParams()}${versiParam}`, h)
            .then((res) => { if (res.data.status) this.setState({ rekap_mapel: res.data.data }); })
            .catch(() => { });
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/bentrokan?${this.getBaseParams()}${versiParam}`, h)
            .then((res) => { if (res.data.status) this.setState({ bentrokan: res.data.data, total_bentrokan: res.data.total_bentrokan, loading: false }); })
            .catch(() => this.setState({ loading: false }));
    }

    renderHariLabel(h) {
        return { 1: "Sen", 2: "Sel", 3: "Rab", 4: "Kam", 5: "Jum", 6: "Sab" }[h] || h;
    }

    render() {
        const { tab, rekap_guru, rekap_mapel, bentrokan, total_bentrokan, versi_list, selected_versi, loading, tahun_ajaran, semester, kurikulum } = this.state;

        return (
            <div className="pc-container">
                <div className="pc-header">
                    <div className="pc-header-content">
                        <div className="pc-header-text">
                            <h1 className="pc-header-title"><i className="bx bx-bar-chart-alt-2"></i> Rekap & Statistik</h1>
                            <p className="pc-header-subtitle">Analisis jam mengajar guru, mapel, dan deteksi bentrokan</p>
                        </div>
                        <div className="pc-header-actions">
                            <Link to="/penjadwalan-cerdas" className="pc-btn pc-btn-outline"><i className="bx bx-arrow-back"></i> Dashboard</Link>
                        </div>
                    </div>
                </div>

                {/* Filters */}
                <div className="pc-filters" style={{ flexWrap: 'wrap' }}>
                    <div className="pc-filter-item">
                        <label>Tahun Ajaran</label>
                        <select className="pc-input" value={tahun_ajaran}
                            onChange={(e) => this.onFilterChange({ tahun_ajaran: e.target.value })}>
                            {this.getTahunAjaranOptions().map((ta) => <option key={ta} value={ta}>{ta}</option>)}
                        </select>
                    </div>
                    <div className="pc-filter-item">
                        <label>Semester</label>
                        <select className="pc-input" value={semester}
                            onChange={(e) => this.onFilterChange({ semester: e.target.value })}>
                            <option value="1">Semester 1 (Ganjil)</option>
                            <option value="2">Semester 2 (Genap)</option>
                        </select>
                    </div>
                    <div className="pc-filter-item">
                        <label>Kurikulum</label>
                        <select className="pc-input" value={kurikulum}
                            onChange={(e) => this.onFilterChange({ kurikulum: e.target.value })}>
                            <option value="merdeka">Kurikulum Merdeka</option>
                            <option value="k13">Kurikulum 2013</option>
                        </select>
                    </div>
                    <div className="pc-filter-item">
                        <label>Versi Jadwal</label>
                        <select className="pc-input" value={selected_versi}
                            onChange={(e) => this.setState({ selected_versi: e.target.value }, () => this.loadAll())}>
                            <option value="">Versi Aktif</option>
                            {versi_list.map((v) => <option key={v.id} value={v.id}>{v.nama_versi}{v.is_aktif ? " (Aktif)" : ""}</option>)}
                        </select>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="pc-stats-grid pc-stats-3">
                    <div className="pc-stat-card pc-stat-indigo">
                        <div className="pc-stat-icon"><i className="bx bx-user"></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{rekap_guru.length}</span>
                            <span className="pc-stat-label">Guru Terjadwal</span>
                        </div>
                    </div>
                    <div className="pc-stat-card pc-stat-emerald">
                        <div className="pc-stat-icon"><i className="bx bx-book-open"></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{rekap_mapel.length}</span>
                            <span className="pc-stat-label">Mapel Terjadwal</span>
                        </div>
                    </div>
                    <div className={`pc-stat-card ${total_bentrokan > 0 ? "pc-stat-rose" : "pc-stat-emerald"}`}>
                        <div className="pc-stat-icon"><i className={`bx ${total_bentrokan > 0 ? "bx-error" : "bx-check-circle"}`}></i></div>
                        <div className="pc-stat-info">
                            <span className="pc-stat-value">{total_bentrokan}</span>
                            <span className="pc-stat-label">Bentrokan</span>
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="pc-tabs">
                    <button className={`pc-tab ${tab === "guru" ? "pc-tab-active" : ""}`} onClick={() => this.setState({ tab: "guru" })}>
                        <i className="bx bx-user"></i> Rekap Guru
                    </button>
                    <button className={`pc-tab ${tab === "mapel" ? "pc-tab-active" : ""}`} onClick={() => this.setState({ tab: "mapel" })}>
                        <i className="bx bx-book-open"></i> Rekap Mapel
                    </button>
                    <button className={`pc-tab ${tab === "bentrokan" ? "pc-tab-active" : ""}`} onClick={() => this.setState({ tab: "bentrokan" })}>
                        <i className="bx bx-error"></i> Bentrokan {total_bentrokan > 0 && <span className="pc-tab-badge">{total_bentrokan}</span>}
                    </button>
                </div>

                {loading ? (
                    <div className="pc-loading"><i className="bx bx-loader-alt bx-spin"></i> Memuat data...</div>
                ) : (
                    <div className="pc-section">
                        {/* Guru Tab */}
                        {tab === "guru" && (
                            <div className="pc-table-container">
                                <table className="pc-table">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Guru</th>
                                            <th>NIP</th>
                                            <th>Total Jam</th>
                                            <th>Hari Aktif</th>
                                            <th>Detail per Hari</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rekap_guru.map((g, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td><strong>{g.guru_nama}</strong></td>
                                                <td>{g.guru_nip || "-"}</td>
                                                <td className="text-center"><span className="pc-badge pc-badge-info">{g.total_jam} jam</span></td>
                                                <td className="text-center">{g.total_hari} hari</td>
                                                <td>
                                                    <div className="pc-detail-hari">
                                                        {(g.detail_per_hari || []).map((d, j) => (
                                                            <span key={j} className="pc-hari-chip">{this.renderHariLabel(d.hari)}: {d.jam}j</span>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {rekap_guru.length === 0 && <tr><td colSpan="6" className="text-center">Tidak ada data</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Mapel Tab */}
                        {tab === "mapel" && (
                            <div className="pc-table-container">
                                <table className="pc-table">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Mapel</th>
                                            <th>Kode</th>
                                            <th>Total Jam</th>
                                            <th>Jumlah Rombel</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rekap_mapel.map((m, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td><strong>{m.mapel_nama}</strong></td>
                                                <td>{m.mapel_kode || "-"}</td>
                                                <td className="text-center"><span className="pc-badge pc-badge-info">{m.total_jam} jam</span></td>
                                                <td className="text-center">{m.total_rombel} rombel</td>
                                            </tr>
                                        ))}
                                        {rekap_mapel.length === 0 && <tr><td colSpan="5" className="text-center">Tidak ada data</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Bentrokan Tab */}
                        {tab === "bentrokan" && (
                            <>
                                {bentrokan.length === 0 ? (
                                    <div className="pc-empty-state pc-empty-success">
                                        <i className="bx bx-check-circle"></i>
                                        <p>Tidak ada bentrokan terdeteksi!</p>
                                        <small>Jadwal sudah optimal dan bebas konflik.</small>
                                    </div>
                                ) : (
                                    <div className="pc-bentrokan-list">
                                        {bentrokan.map((b, i) => (
                                            <div key={i} className="pc-bentrokan-item">
                                                <div className="pc-bentrokan-icon">
                                                    <i className={`bx ${b.tipe === "guru_bentrok" ? "bx-user-x" : "bx-error-alt"}`}></i>
                                                </div>
                                                <div className="pc-bentrokan-info">
                                                    <span className="pc-bentrokan-type">{b.tipe === "guru_bentrok" ? "Guru Bentrok" : "Rombel Bentrok"}</span>
                                                    <p>{b.pesan}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
